import React from "react";
import { Helmet } from "react-helmet";

function HowToInstallBlinds() {
  return (
    <div className="max-w-7xl mx-auto px-6 py-12 text-slate-900 leading-relaxed">
      <Helmet>
        <title>How to Install Blinds | DIY Fitting Guide & Hardware Tips</title>
      </Helmet>

      <h1 className="text-5xl font-black mb-8">How to <span className="text-indigo-600">Install</span> Blinds</h1>
      
      <div className="bg-indigo-50 p-8 rounded-3xl mb-16 flex flex-col md:flex-row gap-8 items-center">
        <div className="md:w-1/3">
          <h3 className="text-xl font-bold mb-4">You Will Need:</h3>
          <ul className="grid grid-cols-2 gap-2 text-sm font-medium">
            <li>✅ Electric Drill</li>
            <li>✅ Screwdriver</li>
            <li>✅ Pencil</li>
            <li>✅ Spirit Level</li>
          </ul>
        </div>
        <div className="md:w-2/3 border-l border-indigo-200 pl-8">
          <p className="text-slate-600 italic">Most blinds can be installed in under 15 minutes. The secret lies in the bracket placement.</p>
        </div>
      </div>

      <section className="grid lg:grid-cols-2 gap-12 mb-24">
        <div>
          <h2 className="text-3xl font-bold mb-6">1. Position the Brackets</h2>
          <p className="mb-4">Decide where your brackets will go. Ensure they are far enough forward so the blind doesn't hit the window handle when lowered.</p>
          
        </div>
        <div>
          <h2 className="text-3xl font-bold mb-6">2. Secure & Clip</h2>
          <p className="mb-4">Once brackets are screwed in, simply "roll" the headrail into place. You should hear a distinct click.</p>
          [Image showing a roller blind headrail being inserted into a universal mounting bracket]
        </div>
      </section>
    </div>
  );
}

export default HowToInstallBlinds;